import React, { useState } from 'react';
import {Form} from "@heroui/form";
import {Button} from "@heroui/button";
import {Input} from "@heroui/input";
import PasswordResetForm from './PasswordResetForm';
// import FacebookLogin from 'react-facebook-login';
import { useGoogleLogin } from '@react-oauth/google';
import AppleLoginButton from './AppleLoginButton';
import { EyeSlashFilledIcon } from './EyeSlashFilledIcon';
import { EyeFilledIcon } from './EyeFilledIcon';

const LoginForm = ({setuser}) => {
  // eslint-disable-next-line no-unused-vars
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState();
  const [showReset, setShowReset] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => setIsVisible(!isVisible);

  const doLogin = async (e) => {
    e.preventDefault();
    let fd = new FormData();
    fd.append('email', email);
    fd.append('password', password);
    const d = await fetch('/api/v1/users/sign_in.json', {method: 'POST', body: fd});
    if (d?.status !== 200) {
      // Failure. You. Failure.
      setError('Login or password incorrect.');
      return false;
    } else {
      // Login success...
      const data = await d.json();
      setuser(data.user);
      return true;
    }
  };

  const hitAppleOmniAuthCallback = async (tokenData) => {
    // Now hit our callback endpoint with the token.
    let fd = new FormData();
    fd.append('code', tokenData['authorization']['code']);
    fd.append('id_token', tokenData['authorization']['id_token']);
    fd.append('access_token', tokenData['authorization']['id_token']);
    fd.append('authorization[code]', tokenData['authorization']['code']);
    fd.append('authorization[id_token]', tokenData['authorization']['id_token']);
    const d = await fetch('/api/v1/users/auth/apple/callback', {method: 'POST', body: fd});
    if (d.status === 200) {
      window.location.reload();
    }
  };

  const hitOmniAuthCallback = async (token) => {
    // Now hit our callback endpoint with the token.
    let fd = new FormData();
    fd.append('access_token', token['access_token']);
    const d = await fetch('/api/v1/users/auth/google_oauth2/callback', {method: 'POST', body: fd});
    if (d.status === 200) {
      window.location.reload();
    }
  };

  const loginGoogle = useGoogleLogin({
    //
    //  {"access_token":"ya29.onMAFC5q9qOA0177","token_type":"Bearer","expires_in":3599,
    //   "scope":"email profile openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
    //   "authuser":"0","hd":"shutdown.com","prompt":"none"}
    //
    onSuccess: (codeResponse) => hitOmniAuthCallback(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });

  return (
    <div style={{border: 'solid 2px #19bccd', width: '360px', backgroundColor: '#4d5c76', borderRadius: '12px', padding: '20px'}}>
      <div style={{color: '#c3ff55', textAlign: 'left', fontSize: '18px', fontWeight: 'bold', marginTop: '6px', marginBottom: '18px'}}>
        ActivistMailer Login
      </div>
      <Button onClick={loginGoogle}>
        <div className="gsi-material-button-state"></div>
        <div className="gsi-material-button-content-wrapper">
          <div style={{width: '150px'}}>
            <div style={{display: 'inline', marginLeft: '-45px'}}>
              <span className="gsi-material-button-contents">Sign in with Google</span>
              <span style={{display: 'none'}}>Sign in with Google</span>
            </div>
            <div className="gsi-material-button-icon" style={{display: 'inline', position: 'absolute', top: '7px', right: '12px'}}>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style={{display: 'block', width: '26px'}}>
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                <path fill="none" d="M0 0h48v48H0z"></path>
              </svg>
            </div>
          </div>
        </div>
      </Button>

      <center>
        <AppleLoginButton performAppleAuth={(data) => hitAppleOmniAuthCallback(data)} />
      </center>

      <div style={{height: '28px'}} />
      <hr style={{paddingBottom: '10px'}} />
      <div style={{fontSize: '18px', marginTop: '-25px', width: '50px', marginLeft: '130px', backgroundColor: '#4d5c76'}}>or</div>

      { showReset
        ? <PasswordResetForm cancelReset={() => setShowReset(false)} loginEmail={email} />
        : <Form onSubmit={doLogin} className="w-full max-w-xs flex flex-col gap-4">
            <div className='error-header'>
              {error}
            </div>
            <Input isRequired label='Your username (your email address)'
                   type='email'
                   color='secondary'
                   variant='bordered'
                   validationBehavior='native'
                   placeholder='mylogin@example.com'
                   onChange={(d) => setEmail(d.target.value)}
            />
            <Input isRequired label='Password'
                   validationBehavior='native'
                   fullWidth='true'
                   color='secondary'
                   variant='bordered'
                   onChange={(d) => setPassword(d.target.value)}
                   type={isVisible ? "text" : "password"}
                   endContent={
                     <button aria-label="toggle password visibility"
                             className="focus:outline-none"
                             type="button"
                             onClick={toggleVisibility}
                     >
                       {isVisible ? (<EyeSlashFilledIcon className="text-2xl text-default-400 pointer-events-none" />)
                                  : (<EyeFilledIcon className="text-2xl text-default-400 pointer-events-none" />)}
                     </button>
                   }
            />
            <div className="flex gap-4 items-center" style={{width: '100%'}}>
              <Button style={{width: '100%'}} color='success' type='submit'>Sign In</Button>
            </div>
            <span style={{textDecoration: 'underline', cursor: 'pointer', fontSize: '14px', color: '#19bccd'}}
                  onClick={() => setShowReset(true)}>
              Forgot password?
            </span>
            <a style={{textDecoration: 'underline', fontSize: '14px', color: '#19bccd'}}
               href='https://activistmailer.com/support-page/'>Support</a>
          </Form>
      }

    </div>
  );
}

export default LoginForm;
